import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rt-thread-expander',
  templateUrl: './thread-expander.component.html',
  styleUrls: ['./thread-expander.component.less'],
})
export class ThreadExpanderComponent {
  @Input() public text: string;

  @Output() public expand = new EventEmitter();
}
